import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeRemaining'
})
export class TimeRemainingPipe implements PipeTransform {

  transform(value: number): unknown {
    if(!value) return;

    let minutes = Math.floor(value/60);
    let remainingSeconds = value - (minutes *60);
    let timeRemaining = `${minutes} min ${remainingSeconds} sec`;
    return timeRemaining;
  }

}
